import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Label,
  Modal,
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory from 'react-bootstrap-table2-filter';
import Moment from 'moment';

import { ProgressButton } from '../../../commons/ProgressButton';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import Services from './services';

import 'moment/locale/hu';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import { DatetimePicker } from '../../../commons/controls'
import TimeFormatter from '../../../commons/TimeFormatter';

// momentLocalizer(Moment);

class UgyfelszolgalatForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bejelentesId: '',
      modositas: false,
      // FORM VALUES
      formTitle: '-',
      formTipus: '',
      formTipusOptions: [],
      formHelyszin: '',
      formHelyszinOptions: [],
      formHatarido: TimeFormatter.formatDate(Moment()),
      baseJson: [],
      formTelefon: '',
      formEmail: '',
      formModalPenzintezet: '',
      formModalBankszamlaszam: '',
      formModalIbanszam: '',
      // -
      formMegjegyzes: '',
      formAllapotMegjegyzes: '',
      formAllapot: '',
      // MODAL UTILS
      modalBankadatTitle: '-',
      modalBankadatButtonText: '-',
      modalBankadat: false,
      // FORM UTILS
      formAllapotOptions: [],
      lek: null,
      submitButtonLoading: false,
      bankButtonLoading: false,
      // STATUS UTILS
      // ['LOAD', 'DATA', 'NETW']
      formCardStatus: 'LOAD',
    };

  }

  componentDidMount() {
    if (this.props.type === 'MOD' || this.props.type === 'SZERK') {
      let params = new URL(window.location.href).searchParams;
      let id = params.get('id');
      this.setState({
        formTitle: 'Panasz, észrevétel: -',
        bejelentesId: id,
        modositas: true,
        lek: this.props && this.props.location && this.props.location.state && this.props.location.state.lek
      }, () => {
        this.getBejelentes(id);
      });
    }
    if (this.props.type === 'FEL') {
      this.setState({
        formTitle: 'Új bejelentés',
        lek: this.props && this.props.location && this.props.location.state && this.props.location.state.lek
      });
      this.initBejelentesForm();
    }
  }

  initBejelentesForm = () => {
    Services.initBejelentesForm((err, res) => {
      if (!err) {
        let formHelyszinOptions = [];
        res[0].helyszin.forEach((item) => {
          formHelyszinOptions.push(
            <option
              value={item.helyszinid}
              key={item.helyszinid}
            >
              {item.helyszinnev}
            </option>
          );
        });
        let formTipusOptions = [];
        res[0].tipus.forEach((item) => {
          formTipusOptions.push(
            <option
              value={item.id}
              key={item.id}
            >
              {item.nev + ' (' + item.hatarido + ' óra)'}
            </option>
          );
        });
        this.setState({
          formTipusOptions: res[0].tipus,
          formHelyszinOptions: formHelyszinOptions,
          formCardStatus: 'DATA',
          formHelyszin: res[0].helyszin.length === 1 ? res[0].helyszin[0].helyszinid : ''
        });
      }
    });
  }

  renderAllapotOptions = () => {
    return this.state.formAllapotOptions.map((item) => {
      return (
        <option
          value={item.id}
          key={item.id}
        >
          {item.nev}
        </option>
      );
    });
  }

  renderTipusOptions = () => {
    return this.state.formTipusOptions.map((item) => {
      return (
        <option
          value={item.id}
          key={item.id}
        >
          {item.nev + ' (' + item.hatarido + ' óra)'}
        </option>
      );
    });
  }

  getBejelentes = (id) => {
    Services.getBejelentes(id, (err, res) => {
      if (!err) {
        let formHelyszinOptions = [];
        res[0].init.helyszin.forEach((item) => {
          formHelyszinOptions.push(
            <option
              value={item.helyszinid}
              key={item.helyszinid}
            >
              {item.helyszinnev}
            </option>
          );
        });
        
        this.setState({
          formCardStatus: 'DATA',
          formTitle: 'Panasz, észrevétel: ' + res[0].azonosito,
          formTipus: res[0].tipusid,
          formTipusOptions: res[0].init.tipus,
          formAllapotOptions: res[0].init.allapot,
          formHelyszin: res[0].helyszinid,
          formHelyszinOptions: formHelyszinOptions,
          formAllapot: res[0].utolsoallapot,
          formAzonosito: res[0].azonosito,
          formNaplo: res[0].naplo,
          formHatarido: res[0].hatarido,
          formBejelento: this.nullToString(res[0].nev),
          formEmail: this.nullToString(res[0].email),
          formTelefon: this.nullToString(res[0].telefon),
          formBejelentes: this.nullToString(res[0].szoveg),
          baseJson: res[0].naplo
        });
      }
    });
  }

  addCegadat = (e, submitObj) => {
    const {
      bejelentesId,
      modositas,
    } = this.state;
    const {
      formTipus,
      formAllapot,
      formHelyszin,
      formHatarido,
      formBejelento,
      formTelefon,
      formEmail,
      formOra,
      formBejelentes,
      formMegjegyzes,
      formAllapotMegjegyzes
    } = submitObj;

    this.setState({ submitButtonLoading: true });

    // if (modositas) submitObj.id = this.emptyOrNull(bejelentesId);
    submitObj.tipusid = this.emptyOrNull(formTipus);
    submitObj.helyszinid = this.emptyOrNull(formHelyszin);
    submitObj.nev = this.emptyOrNull(formBejelento);
    submitObj.email = this.emptyOrNull(formEmail);
    submitObj.tel = this.emptyOrNull(formTelefon);
    submitObj.bejelentes = this.emptyOrNull(formBejelentes);
    submitObj.megjegyzes = this.emptyOrNull(formMegjegyzes);
    submitObj.ora = this.emptyOrNull(formOra);
    submitObj.hatarido = TimeFormatter.format(this.emptyOrNull(formHatarido), "YYYY-MM-DDTHH:mm:ss.SSSZZ");

    if (modositas) {
      if (this.props.type === 'SZERK') {
        const naploObj = {
          id: bejelentesId,
          allapotid: formAllapot,
          megjegyzes: formAllapotMegjegyzes
        };
        Services.editNaplo(naploObj, (err, res) => {
          if (!err) {
            this.setState({ submitButtonLoading: false });
            if (res[0] == true) {
              this.props.globals.addSuccess('Napló módosítva!');
            }
            this.onBack();
          } else {
            this.setState({ submitButtonLoading: false });
          }
        });
      } else {
        submitObj.id = bejelentesId;
        Services.editBejelentes(submitObj, (err) => {
          if (!err) {
            this.setState({ submitButtonLoading: false });
            this.props.globals.addSuccess('Bejelentés módosítva!');
            this.onBack();
          } else {
            this.setState({ submitButtonLoading: false });
          }
        });
      }
    } else {
      Services.addBejelentes(submitObj, (err) => {
        if (!err) {
          this.setState({ submitButtonLoading: false });
          this.props.globals.addSuccess('Bejelentés felvéve!');
          this.onBack();
        } else {
          this.setState({ submitButtonLoading: false });
        }
      });
    }
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  emptyToZero = (data) => {
    if (!data || data === '') return 0;
    return data;
  }

  onBack = () => {
    this.props.globals.route.navigate({
      pathname: this.props.globals.public_url.concat('/admin/ugyfelszolgalat/esetek'),
      state: {
        lek: this.state.lek
      }
    });
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleOraInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value,
      formHatarido: Moment().add(value, 'hours')
    });
  }

  handleTipusInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;

    let hours = 0;

    this.state.formTipusOptions.forEach((tipus) => {
      if (tipus.id == value) hours = tipus.hatarido;
    });

    this.setState({
      [name]: value,
      formOra: hours,
      formHatarido: Moment().add(hours, 'hours')
    });
  }

  handleDateInputChange = (e, v, name) => {
    this.setState({
      [name]: e
    });
  }

  getCorrectTextColor = (hex) => {
    /*
    From this W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast

    Color brightness is determined by the following formula:
    ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000

    I know this could be more compact, but I think this is easier to read/explain.

    */

    let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

    function cutHex(h) { return (h.charAt(0) === '#') ? h.substring(1, 7) : h; }
    function hexToR(h) { return parseInt((cutHex(h)).substring(0, 2), 16); }
    function hexToG(h) { return parseInt((cutHex(h)).substring(2, 4), 16); }
    function hexToB(h) { return parseInt((cutHex(h)).substring(4, 6), 16); }

    let hRed = hexToR(hex);
    let hGreen = hexToG(hex);
    let hBlue = hexToB(hex);

    let cBrightness = ((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000;
    if (cBrightness > threshold) { return '#000000'; } return '#ffffff';
  }

  allapotFormatter = (cell, row) => {
    return (
      <span style={{
        color: this.getCorrectTextColor('#' + row.szin)
      }}
      >
        {cell}
      </span>
    );
  }

  timezoneToDate = (date) => {
    if (!date || date === '') return null;
    return TimeFormatter.formatDateTime(date);
  }

  renderTable = () => {
    const columns = [
      {
        dataField: 'mod',
        text: 'Módosítás időpontja',
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        formatter: this.timezoneToDate,
        sort: false
      },
      {
        dataField: 'allapot',
        text: 'Állapot',
        style: (cell, row, rowIndex, colIndex) => {
          return {
            wordBreak: 'break-all',
            whiteSpace: 'pre-line',
            backgroundColor: '#' + row.szin
          };
        },
        formatter: this.allapotFormatter,
        sort: false
      },
      {
        dataField: 'moduser',
        text: 'Módosító',
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: false
      },
      {
        dataField: 'megjegyzes',
        text: 'Megjegyzés',
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: false
      },
      {
        dataField: 'id',
        text: '-',
        hidden: true
      }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.baseJson}
          columns={columns}
          wrapperClasses="table-responsive"
          classes="table-scroll"
          headerClasses="table-th"
          filter={filterFactory()}
          // pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

  renderFormCardLogic = () => {
    const {
      formTipus,
      formAzonosito,
      formHelyszin,
      formHatarido,
      formOra,
      formBejelento,
      formTelefon,
      formEmail,
      formBejelentes,
      formMegjegyzes,
      formAllapot,
      formAllapotMegjegyzes
    } = this.state;

    const titleStyle = {
      marginBottom: 20,
      marginTop: 10
    };

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12">
            <h5 style={titleStyle}>Bejelentés adatai:</h5>
          </div>
        </div>
        <div className="row">
          {(this.props.type === 'MOD' || this.props.type === 'SZERK') && (
            <div className="col-md-3">
              <RFField
                label="Azonosító:"
                name="formAzonosito"
                value={formAzonosito}
                disabled
                onChange={this.handleTipusInputChange}
              />
            </div>
          )}
          <div className="col-md-3">
            <RFField
              label="Típus: *"
              type="select"
              name="formTipus"
              required
              value={formTipus}
              disabled={this.props.type === 'SZERK'}
              onChange={this.handleTipusInputChange}
              defaultSelect={<option value="">Válassz esettípust...</option>}
              selectOptions={this.renderTipusOptions()}
            />
          </div>
          <div className="col-md-3">
            <RFField
              label="Helyszín: *"
              type="select"
              name="formHelyszin"
              required
              value={formHelyszin}
              disabled={this.props.type === 'SZERK'}
              onChange={this.handleInputChange}
              defaultSelect={<option value="">Válassz helyszínt...</option>}
              selectOptions={this.state.formHelyszinOptions}
            />
          </div>
          {this.props.type === 'FEL' && (
            <div className="col-md-3">
              <RFField
                label="Határidő (óra): "
                type="number"
                name="formOra"
                // required
                value={formOra}
                onChange={this.handleOraInputChange}
                disabled={this.props.type === 'SZERK'}
              />
            </div>
          )}
          <div className="col-md-3">
            <DatetimePicker
              label={'Határidő:'}
              containerClassName="organw-date-time"
              // format="YYYY-MM-DD HH:mm:ss"
              date={this.props.type === 'MOD'}
              time={this.props.type === 'MOD'}
              messages={{ dateButton: 'dátum', timeButton: 'idő' }}
              onChange={(e, v) => this.handleDateInputChange(e, v, 'formHatarido')}
              value={formHatarido && new Date(formHatarido)}
              disabled={this.props.type === 'SZERK' || this.props.type === 'FEL'}
              name="formHatarido"
              id="formHatarido"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <RFField
              label="Bejelentő: *"
              name="formBejelento"
              value={formBejelento}
              onChange={this.handleInputChange}
              disabled={this.props.type === 'SZERK'}
              maxLength="150"
              required
            />
          </div>
          <div className="col-md-4">
            <RFField
              label="E-mail: "
              name="formEmail"
              value={formEmail}
              onChange={this.handleInputChange}
              disabled={this.props.type === 'SZERK'}
              maxLength="100"
            />
          </div>
          <div className="col-md-4">
            <RFField
              label="Telefon: "
              name="formTelefon"
              value={formTelefon}
              onChange={this.handleInputChange}
              disabled={this.props.type === 'SZERK'}
              maxLength="100"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <RFField
              label="Bejelentés:"
              className="munkalap-profil-textarea"
              type="textarea"
              name="formBejelentes"
              maxLength="350"
              value={formBejelentes}
              onChange={this.handleInputChange}
              disabled={this.props.type === 'SZERK'}
            />
          </div>
        </div>
        {this.props.type === 'FEL' && (
          <div className="row">
            <div className="col-md-12">
              <RFField
                label="Megjegyzés:"
                // className="munkalap-profil-textarea"
                // type="textarea"
                name="formMegjegyzes"
                maxLength="350"
                value={formMegjegyzes}
                onChange={this.handleInputChange}
              />
            </div>
          </div>
        )}
        { this.state.modositas && (
          <div className="row">
            <div className="col-md-12">
              {this.renderTable()}
            </div>
          </div>
        )}
        { this.props.type === 'SZERK' && (
          <div className="row">
            <div className="col-md-3">
              <RFField
                label="Állapot: *"
                type="select"
                name="formAllapot"
                required
                value={formAllapot}
                // disabled={this.state.modositas}
                onChange={this.handleInputChange}
                defaultSelect={<option value="">Válassz állapotot...</option>}
                selectOptions={this.renderAllapotOptions()}
              />
            </div>
            <div className="col-md-9">
              <RFField
                label="Megjegyzés: "
                name="formAllapotMegjegyzes"
                value={formAllapotMegjegyzes}
                onChange={this.handleInputChange}
              />
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-md-12">
            <ProgressButton
              color="primary"
              style={{ cursor: 'pointer' }}
              loading={this.state.submitButtonLoading}
            >
              {'Mentés'}
            </ProgressButton>
            {' '}
            <Button
              color="secondary"
              onClick={this.onBack}
              style={{ cursor: 'pointer' }}
            >
              {'Vissza'}
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderFormCard = () => {
    const cardStyle = {
      padding: 20
    };

    return (
      <div className="animated fadeIn">
        <div className="card">
          <div className="card-header">
            {this.state.formTitle}
          </div>
          <RFForm onSubmit={this.addCegadat}>
            <div style={cardStyle}>
              {{
                LOAD: (<div className="col-md-12"><Loader /></div>),
                NETW: (<NetworkEmptyState
                  hasImage
                  submitClick={() => this.getBejelentes(this.state.bejelentesId)}
                />),
                DATA: (this.renderFormCardLogic())
              }[this.state.formCardStatus]}
            </div>
          </RFForm>
        </div>
      </div>
    );
  }

  render() {
    const {
      formModalBankszamlaszam,
      formModalPenzintezet,
      formModalIbanszam
    } = this.state;

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12">
            {this.renderFormCard()}
          </div>
        </div>
        <Modal isOpen={this.state.modalBankadat} toggle={this.toggleBankadat} backdrop="static">
          <RFForm
            modal
            onSubmit={this.addBankadat}
            title={this.state.modalBankadatTitle}
            footer={
              <>
                <ProgressButton color="primary" loading={this.state.bankButtonLoading}>{this.state.modalBankadatButtonText}</ProgressButton>
                <Button type="button" color="secondary" onClick={this.toggleBankadat}>Mégsem</Button>
              </>
            }
          >
            <div className="row">
              <div className="col-md-12">
                <RFField
                  label="Számlavezető pénzintézet neve: *"
                  name="formModalPenzintezet"
                  value={formModalPenzintezet}
                  onChange={this.handleInputChange}
                  maxLength="100"
                  required
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <RFField
                  label="Bankszámlaszám: *"
                  name="formModalBankszamlaszam"
                  value={formModalBankszamlaszam}
                  onChange={this.handleInputChange}
                  pattern="^[\d-]+$"
                  maxLength="100"
                  required
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <RFField
                  label="IBAN szám: "
                  name="formModalIbanszam"
                  value={formModalIbanszam}
                  onChange={this.handleInputChange}
                  maxLength="100"
                // required
                />
              </div>
            </div>
          </RFForm>
        </Modal>
      </React.Fragment>
    );
  }
}

UgyfelszolgalatForm.propTypes = {
  globals: PropTypes.object
};

export default UgyfelszolgalatForm;
